/**
 * Converts snake_case strings to Title Case
 * @param str - The snake_case string to convert
 * @returns The string in Title Case format
 */
export function normalizeSnakeCase(str: string | null | undefined): string {
  if (!str) return ''

  return str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

/**
 * Common role and type mappings for better display
 */
export const roleTypeDisplayMap: Record<string, string> = {
  // Common roles
  medical_director: 'Medical Director',
  program_director: 'Program Director',
  nurse_manager: 'Nurse Manager',
  nurse_practitioner: 'Nurse Practitioner',
  physician_assistant: 'Physician Assistant',
  registered_nurse: 'Registered Nurse',
  social_worker: 'Social Worker',
  case_manager: 'Case Manager',
  research_coordinator: 'Research Coordinator',
  clinical_coordinator: 'Clinical Coordinator',
  administrative_assistant: 'Administrative Assistant',
  data_analyst: 'Data Analyst',

  // Employee types
  full_time: 'Full Time',
  part_time: 'Part Time',
  contract: 'Contract',
  volunteer: 'Volunteer',
  consultant: 'Consultant',

  // Other common terms
  phd: 'PhD',
  md: 'MD',
  rn: 'RN',
  np: 'NP',
  pa: 'PA',
  lcsw: 'LCSW',
  mph: 'MPH'
}

/**
 * Normalizes a role or type string for display
 * Uses specific mappings when available, otherwise converts snake_case to Title Case
 */
export function normalizeRoleOrType(str: string | null | undefined): string {
  if (!str) return ''

  // Check if we have a specific mapping
  const lowerStr = str.toLowerCase()
  if (roleTypeDisplayMap[lowerStr]) {
    return roleTypeDisplayMap[lowerStr]
  }

  // Otherwise, use generic snake_case conversion
  return normalizeSnakeCase(str)
}
